var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCalendarCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1a1 1 0 0 1 .993.883L17 2v1h2a3 3 0 0 1 2.995 2.823L22 6v13c0 1.652-1.348 3-3 3H5c-1.656 0-3-1.346-3-3V6c0-1.662 1.338-3 3-3h2V2a1 1 0 0 1 1.993-.117L9 2v1h6V2a1 1 0 0 1 1-1zm4 9H4v9c0 .51.387.935.884.993L5 20h14c.548 0 1-.452 1-1v-9zM7.013 15.729l.116.006a1.257 1.257 0 0 1 1.134 1.244 1.26 1.26 0 0 1-1.25 1.25c-.695 0-1.25-.57-1.25-1.25 0-.649.49-1.18 1.122-1.244l.128-.006zm5 0 .117.006a1.254 1.254 0 0 1 1.133 1.244 1.26 1.26 0 0 1-1.25 1.25c-.695 0-1.25-.57-1.25-1.25 0-.649.49-1.18 1.122-1.244l.128-.006zm-5-4 .116.006a1.257 1.257 0 0 1 1.134 1.244 1.26 1.26 0 0 1-1.25 1.25c-.695 0-1.25-.57-1.25-1.25 0-.649.49-1.18 1.122-1.244l.128-.006zm5 0 .117.006a1.254 1.254 0 0 1 1.133 1.244 1.26 1.26 0 0 1-1.25 1.25c-.695 0-1.25-.57-1.25-1.25 0-.649.49-1.18 1.122-1.244l.128-.006zm5 0 .116.006a1.257 1.257 0 0 1 1.134 1.244 1.26 1.26 0 0 1-1.25 1.25c-.695 0-1.25-.57-1.25-1.25 0-.649.49-1.18 1.122-1.244l.128-.006zM7 5H5c-.558 0-1 .442-1 1v2h16V6a1 1 0 0 0-.883-.993L19 5h-2v1a1 1 0 0 1-1.993.117L15 6V5H9v1a1 1 0 0 1-1.993.117L7 6V5z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCalendarCustom);
export default __webpack_public_path__ + "static/media/icons-calendar-custom.8f13ea845442b3d79e66e78ab254a290.svg";
export { ForwardRef as ReactComponent };